export default "__VITE_ASSET__0VwOGvpe__"